// assets/images/Host/Cash/cash.js

// --- BLUE ---
import BLUE_1_1 from "assets/images/Host/Cash/BLUE_1_1.png";
import BLUE_2_1 from "assets/images/Host/Cash/BLUE_2_1.png";
import BLUE_2_2 from "assets/images/Host/Cash/BLUE_2_2.png";
import BLUE_3_1 from "assets/images/Host/Cash/BLUE_3_1.png";
import BLUE_3_2 from "assets/images/Host/Cash/BLUE_3_2.png";
import BLUE_3_3 from "assets/images/Host/Cash/BLUE_3_3.png";
import BLUE_4_1 from "assets/images/Host/Cash/BLUE_4_1.png";
import BLUE_4_2 from "assets/images/Host/Cash/BLUE_4_2.png";
import BLUE_4_3 from "assets/images/Host/Cash/BLUE_4_3.png";
import BLUE_4_4 from "assets/images/Host/Cash/BLUE_4_4.png";

// --- GREEN ---
import GREEN_1_1 from "assets/images/Host/Cash/GREEN_1_1.png";
import GREEN_2_1 from "assets/images/Host/Cash/GREEN_2_1.png";
import GREEN_2_2 from "assets/images/Host/Cash/GREEN_2_2.png";
import GREEN_3_1 from "assets/images/Host/Cash/GREEN_3_1.png";
import GREEN_3_2 from "assets/images/Host/Cash/GREEN_3_2.png";
import GREEN_3_3 from "assets/images/Host/Cash/GREEN_3_3.png";
import GREEN_4_1 from "assets/images/Host/Cash/GREEN_4_1.png";
import GREEN_4_2 from "assets/images/Host/Cash/GREEN_4_2.png";
import GREEN_4_3 from "assets/images/Host/Cash/GREEN_4_3.png";
import GREEN_4_4 from "assets/images/Host/Cash/GREEN_4_4.png";

// --- RED ---
import RED_1_1 from "assets/images/Host/Cash/RED_1_1.png";
import RED_2_1 from "assets/images/Host/Cash/RED_2_1.png";
import RED_2_2 from "assets/images/Host/Cash/RED_2_2.png";
import RED_3_1 from "assets/images/Host/Cash/RED_3_1.png";
import RED_3_2 from "assets/images/Host/Cash/RED_3_2.png";
import RED_3_3 from "assets/images/Host/Cash/RED_3_3.png";
import RED_4_1 from "assets/images/Host/Cash/RED_4_1.png";
import RED_4_2 from "assets/images/Host/Cash/RED_4_2.png";
import RED_4_3 from "assets/images/Host/Cash/RED_4_3.png";
import RED_4_4 from "assets/images/Host/Cash/RED_4_4.png";

// --- YELLOW ---
import YELLOW_1_1 from "assets/images/Host/Cash/YELLOW_1_1.png";
import YELLOW_2_1 from "assets/images/Host/Cash/YELLOW_2_1.png";
import YELLOW_2_2 from "assets/images/Host/Cash/YELLOW_2_2.png";
import YELLOW_3_1 from "assets/images/Host/Cash/YELLOW_3_1.png";
import YELLOW_3_2 from "assets/images/Host/Cash/YELLOW_3_2.png";
import YELLOW_3_3 from "assets/images/Host/Cash/YELLOW_3_3.png";
import YELLOW_4_1 from "assets/images/Host/Cash/YELLOW_4_1.png";
import YELLOW_4_2 from "assets/images/Host/Cash/YELLOW_4_2.png";
import YELLOW_4_3 from "assets/images/Host/Cash/YELLOW_4_3.png";
import YELLOW_4_4 from "assets/images/Host/Cash/YELLOW_4_4.png";

// --- CYAN ---
import CYAN_1_1 from "assets/images/Host/Cash/CYAN_1_1.png";
import CYAN_2_1 from "assets/images/Host/Cash/CYAN_2_1.png";
import CYAN_2_2 from "assets/images/Host/Cash/CYAN_2_2.png";
import CYAN_3_1 from "assets/images/Host/Cash/CYAN_3_1.png";
import CYAN_3_2 from "assets/images/Host/Cash/CYAN_3_2.png";
import CYAN_3_3 from "assets/images/Host/Cash/CYAN_3_3.png";
import CYAN_4_1 from "assets/images/Host/Cash/CYAN_4_1.png";
import CYAN_4_2 from "assets/images/Host/Cash/CYAN_4_2.png";
import CYAN_4_3 from "assets/images/Host/Cash/CYAN_4_3.png";
import CYAN_4_4 from "assets/images/Host/Cash/CYAN_4_4.png";

// --- PURPLE ---
import PURPLE_1_1 from "assets/images/Host/Cash/PURPLE_1_1.png";
import PURPLE_2_1 from "assets/images/Host/Cash/PURPLE_2_1.png";
import PURPLE_2_2 from "assets/images/Host/Cash/PURPLE_2_2.png";
import PURPLE_3_1 from "assets/images/Host/Cash/PURPLE_3_1.png";
import PURPLE_3_2 from "assets/images/Host/Cash/PURPLE_3_2.png";
import PURPLE_3_3 from "assets/images/Host/Cash/PURPLE_3_3.png";
import PURPLE_4_1 from "assets/images/Host/Cash/PURPLE_4_1.png";
import PURPLE_4_2 from "assets/images/Host/Cash/PURPLE_4_2.png";
import PURPLE_4_3 from "assets/images/Host/Cash/PURPLE_4_3.png";
import PURPLE_4_4 from "assets/images/Host/Cash/PURPLE_4_4.png";

// --- ORANGE ---
import ORANGE_1_1 from "assets/images/Host/Cash/ORANGE_1_1.png";
import ORANGE_2_1 from "assets/images/Host/Cash/ORANGE_2_1.png";
import ORANGE_2_2 from "assets/images/Host/Cash/ORANGE_2_2.png";
import ORANGE_3_1 from "assets/images/Host/Cash/ORANGE_3_1.png";
import ORANGE_3_2 from "assets/images/Host/Cash/ORANGE_3_2.png";
import ORANGE_3_3 from "assets/images/Host/Cash/ORANGE_3_3.png";
import ORANGE_4_1 from "assets/images/Host/Cash/ORANGE_4_1.png";
import ORANGE_4_2 from "assets/images/Host/Cash/ORANGE_4_2.png";
import ORANGE_4_3 from "assets/images/Host/Cash/ORANGE_4_3.png";
import ORANGE_4_4 from "assets/images/Host/Cash/ORANGE_4_4.png";

// --- PINK ---
import PINK_1_1 from "assets/images/Host/Cash/PINK_1_1.png";
import PINK_2_1 from "assets/images/Host/Cash/PINK_2_1.png";
import PINK_2_2 from "assets/images/Host/Cash/PINK_2_2.png";
import PINK_3_1 from "assets/images/Host/Cash/PINK_3_1.png";
import PINK_3_2 from "assets/images/Host/Cash/PINK_3_2.png";
import PINK_3_3 from "assets/images/Host/Cash/PINK_3_3.png";
import PINK_4_1 from "assets/images/Host/Cash/PINK_4_1.png";
import PINK_4_2 from "assets/images/Host/Cash/PINK_4_2.png";
import PINK_4_3 from "assets/images/Host/Cash/PINK_4_3.png";
import PINK_4_4 from "assets/images/Host/Cash/PINK_4_4.png";

// Public color keys (case-insensitive in helper)
export const COLORS = {
    BLUE: "BLUE",
    GREEN: "GREEN",
    RED: "RED",
    YELLOW: "YELLOW",
    CYAN: "CYAN",
    PURPLE: "PURPLE",
    ORANGE: "ORANGE",
    PINK: "PINK",
};

/**
 * Static map:
 * CASH_IMAGES[color][slotCount][slotIndex] = image url
 * - slotCount ∈ {1,2,3,4}
 * - slotIndex is 1-based within that count
 */
export const CASH_IMAGES = {
    [COLORS.BLUE]: {
        1: { 1: BLUE_1_1 },
        2: { 1: BLUE_2_1, 2: BLUE_2_2 },
        3: { 1: BLUE_3_1, 2: BLUE_3_2, 3: BLUE_3_3 },
        4: { 1: BLUE_4_1, 2: BLUE_4_2, 3: BLUE_4_3, 4: BLUE_4_4 },
    },
    [COLORS.GREEN]: {
        1: { 1: GREEN_1_1 },
        2: { 1: GREEN_2_1, 2: GREEN_2_2 },
        3: { 1: GREEN_3_1, 2: GREEN_3_2, 3: GREEN_3_3 },
        4: { 1: GREEN_4_1, 2: GREEN_4_2, 3: GREEN_4_3, 4: GREEN_4_4 },
    },
    [COLORS.RED]: {
        1: { 1: RED_1_1 },
        2: { 1: RED_2_1, 2: RED_2_2 },
        3: { 1: RED_3_1, 2: RED_3_2, 3: RED_3_3 },
        4: { 1: RED_4_1, 2: RED_4_2, 3: RED_4_3, 4: RED_4_4 },
    },
    [COLORS.YELLOW]: {
        1: { 1: YELLOW_1_1 },
        2: { 1: YELLOW_2_1, 2: YELLOW_2_2 },
        3: { 1: YELLOW_3_1, 2: YELLOW_3_2, 3: YELLOW_3_3 },
        4: { 1: YELLOW_4_1, 2: YELLOW_4_2, 3: YELLOW_4_3, 4: YELLOW_4_4 },
    },
    [COLORS.CYAN]: {
        1: { 1: CYAN_1_1 },
        2: { 1: CYAN_2_1, 2: CYAN_2_2 },
        3: { 1: CYAN_3_1, 2: CYAN_3_2, 3: CYAN_3_3 },
        4: { 1: CYAN_4_1, 2: CYAN_4_2, 3: CYAN_4_3, 4: CYAN_4_4 },
    },
    [COLORS.PURPLE]: {
        1: { 1: PURPLE_1_1 },
        2: { 1: PURPLE_2_1, 2: PURPLE_2_2 },
        3: { 1: PURPLE_3_1, 2: PURPLE_3_2, 3: PURPLE_3_3 },
        4: { 1: PURPLE_4_1, 2: PURPLE_4_2, 3: PURPLE_4_3, 4: PURPLE_4_4 },
    },
    [COLORS.ORANGE]: {
        1: { 1: ORANGE_1_1 },
        2: { 1: ORANGE_2_1, 2: ORANGE_2_2 },
        3: { 1: ORANGE_3_1, 2: ORANGE_3_2, 3: ORANGE_3_3 },
        4: { 1: ORANGE_4_1, 2: ORANGE_4_2, 3: ORANGE_4_3, 4: ORANGE_4_4 },
    },
    [COLORS.PINK]: {
        1: { 1: PINK_1_1 },
        2: { 1: PINK_2_1, 2: PINK_2_2 },
        3: { 1: PINK_3_1, 2: PINK_3_2, 3: PINK_3_3 },
        4: { 1: PINK_4_1, 2: PINK_4_2, 3: PINK_4_3, 4: PINK_4_4 },
    },
};

export const REVEAL_CASH_IMAGES = {
    [COLORS.BLUE]: BLUE_1_1,
    [COLORS.GREEN]: GREEN_1_1,
    [COLORS.RED]: RED_1_1,
    [COLORS.YELLOW]: YELLOW_1_1,
    [COLORS.CYAN]: CYAN_1_1,
    [COLORS.PURPLE]: PURPLE_1_1,
    [COLORS.ORANGE]: ORANGE_1_1,
    [COLORS.PINK]: PINK_1_1,
};

/**
 * Helper to safely fetch an image.
 * - color: "blue" | "GREEN" | etc (case-insensitive)
 * - slotCount: 1 | 2 | 3 | 4
 * - slotIndex: 1-based index within slotCount
 * If out of range, it clamps slotIndex into valid range.
 */
export function getCashImage(color, slotCount = 4, slotIndex = 1, isRevealState /* formerly isRevewlState */) {
    const c = String(color || "").toUpperCase();
    const colorKey = COLORS[c] ? c : COLORS.BLUE; // default BLUE if unknown

    if (isRevealState) return REVEAL_CASH_IMAGES[colorKey];

    const count = [1, 2, 3, 4].includes(Number(slotCount)) ? Number(slotCount) : 4;

    const table = CASH_IMAGES[colorKey]?.[count];
    if (!table) return undefined;

    const maxIndex = Object.keys(table).length;
    const index = Math.min(Math.max(1, Number(slotIndex) || 1), maxIndex);

    return table[index];
}

/**
 * Optional: array form for easy iteration:
 * CASH_ARRAYS[color][slotCount] = [img1, img2, ...]
 */
export const CASH_ARRAYS = Object.fromEntries(
    Object.entries(CASH_IMAGES).map(([color, counts]) => {
        const toArray = (obj) =>
            Object.keys(obj)
                .map(Number)
                .sort((a, b) => a - b)
                .map((k) => obj[k]);
        return [
            color,
            {
                1: toArray(counts[1]),
                2: toArray(counts[2]),
                3: toArray(counts[3]),
                4: toArray(counts[4]),
            },
        ];
    })
);

export default CASH_IMAGES;